import { useEffect, useState } from "react";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import {
  IDeltaHedgeAccountAggregateReportSearchParam,
  IDeltaHedgeAccountDetailReportSearchParam,
} from "../../../Interfaces/deltaHedgeAccounts";
import { getGroups } from "../../../Requests/optionDomain";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import SelectableButtons from "../../../Components/Dropdown/SelectableButtons";
import DetailsTable from "../../../Tables/DeltaHedgeAccount/Details/DetailsTable";
import {
  getAccountPortfoExcel,
  getDeltaHedgeAccountsDropdown,
} from "../../../Requests/deltaHedgeAccounts";
import FileDownloader from "../../../Components/FileDownloader";
import AccountPortfoTable from "../../../Tables/DeltaHedgeAccount/Details/AccountPortfoTable";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import ApplyList from "./ApplyList";
import { Report } from "../../../Interfaces/TableInterfaces";
import CheckBox from "../../../Components/Checkbox";
import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import { IFilterTableCols } from "src/Tables/TableTemplate/tableTemplate";

interface IVisibleHeaders {
  detail: boolean;
  mediator: boolean;
}

const Details = () => {
  const [groups, setGroups] = useState([] as DropdownItem[]);
  const [searchParams, setSearchParams] = useState(
    {} as IDeltaHedgeAccountDetailReportSearchParam
  );
  const [isApplyListOpen, setIsApplyListOpen] = useState(false);
  const [visibleHeaders, setVisibleHeaders] = useState({} as IVisibleHeaders);

  useEffect(() => {
    getGroups()
      .then((resp) => {
        setGroups(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  const getFilterCols = (): IFilterTableCols => {
    const result: IFilterTableCols = {
      show: true,
      tableName: "accountPortfoTable",
      allowedPositions: [],
    };
    if (visibleHeaders.detail) result.allowedPositions.push("DefaultHidden");
    if (visibleHeaders.mediator) result.allowedPositions.push("Mediator");
    return result;
  };

  const visibleHeaderChangeHandler = (name: string, value: any) => {
    setVisibleHeaders({ ...visibleHeaders, [name]: value } as IVisibleHeaders);
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      {isApplyListOpen ? (
        <Modal
          onClose={() => setIsApplyListOpen(false)}
          UI={<ApplyList onClose={() => setIsApplyListOpen(false)} />}
        />
      ) : (
        <></>
      )}
      <div className="w-min">
        <Button
          text="لیست اعمالی"
          variant="contained"
          onClick={() => setIsApplyListOpen(true)}
        />
      </div>
      <div className="flex flex-row justify-start items-center w-full gap-8">
        <div className="w-72">
          <DynamicDropdown
            dropdown={{
              placeholder: "اکانت",
              name: "accountId",
              extraLabel: true,
            }}
            onChange={changeHandler}
            value={searchParams.accountId}
            getData={getDeltaHedgeAccountsDropdown}
          />
        </div>
        <SelectableButtons
          label="گروه"
          name="groupId"
          options={groups}
          onChange={changeHandler}
          value={searchParams.groupId?.toString()}
        />
        <div>
          <FileDownloader getFile={getAccountPortfoExcel} />
        </div>
      </div>
      <div className="flex flex-row justify-start items-center gap-5">
        <div className="bg-sky-200 rounded py-1 px-2">
          <CheckBox
            checked={visibleHeaders.detail}
            label="جزئیات"
            name="detail"
            onChange={visibleHeaderChangeHandler}
          />
        </div>
        <div className="bg-red-200 rounded py-1 px-2">
          <CheckBox
            checked={visibleHeaders.mediator}
            label="محاسبات"
            name="mediator"
            onChange={visibleHeaderChangeHandler}
          />
        </div>
      </div>
      <DetailsTable
        searchParams={{
          ...searchParams,
          groupId: searchParams.groupId || (undefined as any),
        }}
      />
      <AccountPortfoTable
        searchParams={{
          ...searchParams,
          groupId: searchParams.groupId || (undefined as any),
        }}
        filterCols={getFilterCols()}
      />
    </div>
  );
};

export default Details;
